<template>
    <div>

        <rkm-area
            title="Cota"
            no-margin-top
        >

            <rkm-button
                @click="$refs.Modal.open()"
                color="primary"
                slot="trailing"
                small
                title="Adicionar cota"
            >
                <rkm-icon icon="plus" />
            </rkm-button>

            <rkm-table
                :items="dados"
                :fields="fields.tables.tipo"
                :filter="filter"
                sort-by="nomeFantasia"
            >

                <template slot="filters">
                    <rkm-row>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                placeholder="Digite para buscar"
                                v-model="filter"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>Buscar</rkm-input-group-text>
                                </rkm-input-group-prepend>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.anos"
                                text-field="cotaAno"
                                v-model="model.cotaAno"
                                @change="handleAnoCota()"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.meses"
                                show-default-option
                                default-option-text="Selecione o mês"
                                text-field="descricao"
                                value-field="id"
                                v-model="model.cotaMes"
                                @change="handleAnoCota()"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-0">
                            <rkm-button
                                :disabled="!filter && !model.cotaMes && !model.cotaAno"
                                @click="handleClearFilter"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:cell(actions)="{ index, item }">
                    <rkm-button
                        @click="$refs.Modal.open(index, item, model.cotaAno)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        @click="handleCota(item)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>

           <Modal
                :data="data"
                ref="Modal"
            />
        </rkm-area>

        <rkm-area
            title="TRANSFERÊNCIA"
            class="mt-3"
        >
            <rkm-button
                @click="$refs.ModalTransferencia.open()"
                color="primary"
                slot="trailing"
                small
                title="Realizar transferência"
            >
                <rkm-icon icon="plus" />
            </rkm-button>

            <rkm-table
                :items="dadosTransferencia"
                :fields="fields.tables.transferencia"
                :filter="filterTransferencia"
                sort-by="laboratorioNomeFantasia"
            >

                <template slot="filters">
                    <rkm-row>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                placeholder="Digite para buscar"
                                v-model="filterTransferencia"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>Buscar</rkm-input-group-text>
                                </rkm-input-group-prepend>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.anos"
                                show-default-option
                                default-option-text="Selecione o ano"
                                text-field="cotaAno"
                                v-model="model.transferenciaAno"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.meses"
                                show-default-option
                                default-option-text="Selecione o mês"
                                text-field="descricao"
                                value-field="id"
                                v-model="model.transferenciaMes"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-0">
                            <rkm-button
                                :disabled="!filterTransferencia && !model.tranferenciaMes && !model.tranferenciaAno"
                                @click="handleClearFilterTransferencia"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:cell(actions)="{ index, item }">

                    <rkm-button
                        @click="$refs.ModalTransferencia.open(index, item)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        @click="handleDestroyTranferencia(item)"
                        color="danger"
                        small
                        title="Excluir"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>

           <ModalTransferencia
                :data="data"
                :transferenciaLaboratorio="model.transferenciaLaboratorio"
                ref="ModalTransferencia"
            />
        </rkm-area>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import Modal from './Modal'
import ModalTransferencia from '../transferencia/Modal'

// Moment.
import moment from 'moment'

// Mixins.
import { repository, object, data, error, formats } from '@/mixins'

// Enums.
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'
import tipoCota from '@/enums/exame-laboratorial/tipoCota'

export default {
    components: { Modal, ModalTransferencia },
    computed: {
        fields() {

            return {
                tables: {
                    tipo: [
                        { key: 'nomeFantasia', label: 'Laboratório', sortable: true },
                        { key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true },
                        { key: 'valorLaboratorio', label: 'Valor', class: 'text-center', sortable: true },
                        { key: 'valorUtilizado', label: 'Utilizado (valor)', class: 'text-center', sortable: true },
                        { key: 'valorSaldo', label: 'Saldo (valor)', class: 'text-center', sortable: true },
                        { key: 'quantidadeLaboratorio', label: 'Quantidade', class: 'text-center', sortable: true },
                        { key: 'quantidadeUtilizada', label: 'Utilizada (quantidade)', class: 'text-center', sortable: true },
                        { key: 'quantidadeSaldo', label: 'Saldo (quantidade)', class: 'text-center', sortable: true },
                        { key: 'ano', label: 'Ano', class: 'text-center', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                    transferencia: [
                        { key: 'laboratorioNomeFantasia', label: 'Laboratório', sortable: true },
                        { key: 'laboratorioInfraestrutura', label: 'Local de atendimento', sortable: true },
                        { key: 'origemNomeFantasia', label: 'Unidade', sortable: true },
                        { key: 'origemInfraestrutura', label: 'Local de atendimento', sortable: true },
                        { key: 'valorUnidade', label: 'Valor', sortable: true },
                        { key: 'quantidadeUnidade', label: 'Quantidade', sortable: true },
                        { key: 'ano', label: 'Ano', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
        dados() {

            let filterItems = this.itemsLaboratorio.map(unidade => {

                let valorSaldo = this.formatSumMoney(unidade.valorLaboratorio) - this.formatSumMoney(unidade.valorUtilizado)
                let quantidadeSaldo = unidade.quantidadeLaboratorio - unidade.quantidadeUtilizada

                return {
                    nomeFantasia: unidade.nomeFantasia,
                    infraestruturaNome: unidade.infraestruturaNome,
                    unidadeId: unidade.unidadeId,
                    infraestruturaId: unidade.infraestruturaId,
                    valorLaboratorio: this.formatMoney(unidade.valorLaboratorio, 2),
                    valorUtilizado: this.formatMoney(unidade.valorUtilizado, 2),
                    valorSaldo: this.formatMoney(valorSaldo, 2),
                    quantidadeLaboratorio: this.formatMoney(unidade.quantidadeLaboratorio, 0),
                    quantidadeUtilizada: this.formatMoney(unidade.quantidadeUtilizada, 0),
                    quantidadeSaldo: this.formatMoney(quantidadeSaldo, 0),
                    ano: unidade.ano,
                    alterado: unidade.alterado,
                }
            })

            return filterItems
        },
        dadosTransferencia() {

            const ano = this.model.transferenciaAno
            const mes = this.model.transferenciaMes

            let filterItems = this.itemsCotasTransferencia.map(unidade => {

                let valorUnidade = unidade.destino
                let quantidadeUnidade =  unidade.destino

                if (ano != null) {

                    valorUnidade = valorUnidade.filter(field => field.origemInicio.substr(6, 4) == ano)
                    quantidadeUnidade = quantidadeUnidade.filter(field => field.origemInicio.substr(6, 4) == ano)
                }

                if (mes != null) {

                    valorUnidade = valorUnidade.filter(field => field.origemInicio.substr(3, 2) == mes)
                    quantidadeUnidade = quantidadeUnidade.filter(field => field.origemInicio.substr(3, 2) == mes)
                }

                valorUnidade = valorUnidade.reduce((sum, element) => sum + this.formatSumMoney(element.destinoCotaValor), 0)

                quantidadeUnidade = quantidadeUnidade.reduce((sum, element) => {

                    if (element.destinoCotaQuantidade) {
                        sum = sum + Number(element.destinoCotaQuantidade);
                    }

                    return sum;
                },0)

                return {
                    id: unidade.id,
                    laboratorioUnidadeId: unidade.laboratorioUnidadeId,
                    laboratorioInfraestruturaId: unidade.laboratorioInfraestruturaId,
                    origemUnidadeId: unidade.origemUnidadeId,
                    origemInfraestruturaId: unidade.origemInfraestruturaId,
                    destino: unidade.destino,
                    laboratorioNomeFantasia: unidade.laboratorioNomeFantasia,
                    laboratorioInfraestrutura: unidade.laboratorioInfraestrutura,
                    origemNomeFantasia: unidade.origemNomeFantasia,
                    origemInfraestrutura: unidade.origemInfraestrutura,
                    valorUnidade: this.formatMoney(valorUnidade, 2),
                    quantidadeUnidade: this.formatMoney(quantidadeUnidade, 0),
                    ano: this.model.transferenciaAno,
                }
            })

            return filterItems
        },
    },
    data: () => ({
        enums: {
            tipoUnidade,
            tipoCota,
        },
        model:{
            cotaAno: null,
            cotaMes: null,
            transferenciaAno: null,
            transferenciaMes: null,
            transferenciaLaboratorio: true,
        },
        filter: null,
        filterTransferencia: null,
    }),
    created() {

        this.repositories = {
            saldo: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }

        this.load()
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.cotaAno = moment().format("YYYY")
            this.model.transferenciaAno = moment().format("YYYY")
        },
        handleCota(item) {

            this.setLoading()

            this.repositories.saldo.saldoUnidadeSolicitante({
                infraestrutura_id: item.infraestruturaId,
            })
                .then(response => {

                    if (response.data.valorAgendado == 0 || response.data.quantidadeAgendada == 0) {

                        this.handleDestroy(item)
                    } else {

                        const unidade = this.data.form.unidades.find(u => u.id === item.unidadeId)
                        const infraestrutura = unidade.infraestruturas.find(u => u.id === item.infraestruturaId)

                        this.showValidationNotification(`Não é possível excluir a cota do laboratório
                            <strong>${ unidade.nomeFantasia }</strong> e o local de atendimento
                            <strong>${ infraestrutura.nome }</strong>, pois já possui agendamentos vinculados a ele.`)

                        return false
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy(item) {

            this.getCotaAtribuida(item)

            if (this.cotasAtribuidas > 0) {

                const unidade = this.data.form.unidades.find(u => u.id === item.unidadeId)
                const infraestrutura = unidade.infraestruturas.find(u => u.id === item.infraestruturaId)

                this.showValidationNotification(`Não é possível excluir a unidade
                    <strong>${ unidade.nomeFantasia }</strong> e o local de atendimento
                    <strong>${ infraestrutura.nome }</strong>, pois já possui cotas atribuídas.`)

                return false
            }

            const objId = this.data.model.cotasLaboratorio.findIndex((obj => obj.unidadeId == item.unidadeId
                    && obj.infraestruturaId == item.infraestruturaId));

            const destroy = async () => this.data.model.cotasLaboratorio.splice(objId, 1)

            this.showDeleteConfirmation('Deseja realmente excluir a cota do laboratório?', destroy)
        },
        handleDestroyTranferencia(item) {

            const objId = this.data.model.cotasTransferencia.findIndex((obj => obj.unidadeId == item.unidadeId
                && obj.infraestruturaId == item.infraestruturaId
                && obj.unidadeTipoId == this.enums.tipoUnidade.LABORATORIO)
            );

            const destroy = async () => this.data.model.cotasTransferencia.splice(objId, 1)

            this.showDeleteConfirmation('Deseja realmente excluir a transferência?', destroy)
        },
        handleClearFilter() {
            this.filter = null
            this.model.cotaMes = null
            this.model.cotaAno = null
        },
        handleClearFilterTransferencia() {
            this.filterTransferencia = null
            this.model.transferenciaAno = null
            this.model.transferenciaMes = null
        },
        getCotaAtribuida(cotasExamePeriodo) {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            const cota = this.data.model.cotasLaboratorio

            if (cota) {

                cota.map(item => item.cotaLaboratorio.filter(field =>
                    field.unidadeId == cotasExamePeriodo.unidadeId && field.infraestruturaId == cotasExamePeriodo.infraestruturaId
                ).map(unidadeSolicitante => {

                    this.cotaAtribuida = unidadeSolicitante.unidadeSolicitante.length + unidadeSolicitante.exames.length

                    this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                    })
                )
            }
        },
        handleAnoCota() {

            this.setLoading()

            this.repositories.saldo.getListagemCotaLaboratorio({
                ano: this.model.cotaAno,
                mes: this.model.cotaMes
            })
                .then(response => {

                    this.data.model.cotasLaboratorio = response.data
                    this.data.model.cotasLaboratorio.push()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    props: {
        data: { type: Object, required: true },
        itemsLaboratorio: { type: Array, required: true },
        itemsCotasTransferencia: { type: Array, required: true },
    },
    mixins: [ repository, object, data, error, formats ],
}
</script>